"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var BasicSelect = _styledComponents["default"].select.attrs(function () {
  return {
    className: "custom-select",
    name: "basic-select"
  };
}).withConfig({
  displayName: "BasicSelect",
  componentId: "sc-3qfq0h-0"
})(["&&&{", ";", ";}"], function (props) {
  return props.disabled ? "background-color: " + props.theme["light-grey"] + " !important;" : "";
}, function (props) {
  return props.disabled ? "color: " + props.theme["grey"] + " !important" : "";
});

var _default = BasicSelect;
exports["default"] = _default;